module.exports = __webpack_public_path__ + "static/media/superai_symbol_md.f84ca5bb.png";